import { useState, useContext, useCallback } from 'react';
import { LoaderContext } from 'shared/context/loaderContext';
import { NotificationContext } from 'shared/context/notificationContext';
import { useCm360Api } from '../../../../../shared/const/api-backend';
import { reportError } from 'shared/services/raygunService';

const useFetchRefund = () => {
  const [error, setError] = useState(null);
  const [refund, setRefund] = useState(null);
  const { showNotification } = useContext(NotificationContext);
  const { setLoading } = useContext(LoaderContext);

  const API = useCm360Api();

  const fetchRefund = useCallback(async (policyId) => {
    try {
      setLoading(true);
      const apiUrl = `/ui-proxy/policies/${policyId}/refund`;
      const response = await API.get(apiUrl);
      if (response.status !== 200) {
        throw new Error('Network response was not ok');
      }

      const responseData = response.data;
      if (!responseData || responseData.length === 0) {
        return [];
      }

      setRefund(responseData);
      return responseData;
    } catch (error) {
      setError(error);
      showNotification('Error fetching payment data', 'error');
      reportError(error);
    } finally {
      setLoading(false);
    }
  }, []);

  return { refund, error, fetchRefund };
};

export default useFetchRefund;
